import { render, staticRenderFns } from "./OpenedEventList.vue?vue&type=template&id=7737c23b"
import script from "./OpenedEventList.vue?vue&type=script&lang=js"
export * from "./OpenedEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports